import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index";
export default {
  mixins: [loadMoreList, commonData],
  data: function data() {
    return {
      dialogFormVisible: false,
      studentId: '',
      tableData: []
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.studentId = data.student_id;

                  _this.getScoreListFn();
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getScoreListFn: function getScoreListFn() {
      var _this2 = this;

      this.$api.disciplineStatus({
        student_id: this.studentId
      }).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          data.forEach(function (item) {
            item.match_name = item.tournament.name || '/';
          });
          _this2.tableData = data;
        }
      });
    }
  }
};